import { useRecoilState } from 'recoil'

import { isSavingAtom, loadingAtom } from './atoms'

// boolean
export const useLoadingState = () => {
  const [flag, setFlag] = useRecoilState(loadingAtom)

  return {
    isTrue: flag,
    isFalse: !flag,
    toggle() {
      setFlag((x) => !x)
    },
    setTrue() {
      setFlag(true)
    },
    setFalse() {
      setFlag(false)
    },
  }
}
export const useIsSavingState = () => {
  const [flag, setFlag] = useRecoilState(isSavingAtom)

  return {
    isTrue: flag,
    isFalse: !flag,
    toggle() {
      setFlag((x) => !x)
    },
    setTrue() {
      setFlag(true)
    },
    setFalse() {
      setFlag(false)
    },
  }
}
